import React, { useState, useEffect } from 'react';
import { LifeDimension, LIFE_DIMENSION_CONFIG } from '../../types/lifeDimension';

interface LifeBalanceBarProps {
  dimension: LifeDimension;
  ripples: number;
}

/**
 * LifeBalanceBar - 生活維度進度條組件
 *
 * 設計規格：
 * - 固定 30 分 = 100% 寬度
 * - 超過 30 分仍顯示為 100%
 * - 使用維度配置的顏色（從 LIFE_DIMENSION_CONFIG）
 * - 流暢的填充動畫效果
 */
export const LifeBalanceBar: React.FC<LifeBalanceBarProps> = ({ dimension, ripples }) => {
  const [displayWidth, setDisplayWidth] = useState(0);
  const config = LIFE_DIMENSION_CONFIG[dimension];

  // 計算進度條寬度：固定 30 分為滿格
  const targetWidth = Math.min((ripples / 30) * 100, 100);

  // 動畫效果：延遲 100ms 後開始填充
  useEffect(() => {
    const timer = setTimeout(() => {
      setDisplayWidth(targetWidth);
    }, 100);
    return () => clearTimeout(timer);
  }, [targetWidth]);

  return (
    <div className="flex items-center gap-3 mb-3">
      {/* 維度標籤 */}
      <div className="flex items-center gap-2 w-24 flex-shrink-0">
        <config.icon className={`w-4 h-4 ${config.iconColor}`} />
        <span className="text-sm text-gray-700 font-medium">
          {config.label}
        </span>
      </div>

      {/* 進度條容器 */}
      <div className="flex-1 h-8 bg-gray-100 rounded-full overflow-hidden relative">
        {/* 進度條填充 */}
        <div
          className={`h-full rounded-full flex items-center justify-end px-3 ${config.bgColor} transition-all duration-700 ease-out`}
          style={{ width: `${displayWidth}%` }}
        >
          <span className={`text-xs font-semibold ${config.iconColor}`}>
            +{ripples}
          </span>
        </div>
      </div>
    </div>
  );
};
